<page-content>
    <header-elitment header>
    </header-elitment>
    <side-menu left-menu>
    </side-menu>
    <div>

    </div>
    <footer-elitment footer></footer-elitment>
</page-content>
